var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con-left"},[_c('img',{staticStyle:{"margin-top":"111px"},attrs:{"src":_vm.menuslogon,"width":"271px","height":"90px"}}),_c('div',{staticClass:"left-font"},[_vm._v("埃克森美孚（中国）投资有限公司")])])
}
var staticRenderFns = []

export { render, staticRenderFns }